<template>
	<div class="input-group input-group-sm">
		<span class="input-group-addon input-group-addon-color">{{item.desc}}</span>
		<div>
			<input class="form-control" :title="item.unit" type="number" v-mynumber="{class:''}" :value="(item.value*item.conversion).toFixed(2)"
				@input="item.value=$event.target.value/item.conversion" :min="item.min" :max="item.max" :step="item.step" />
		</div>
	</div>
</template>

<script>
	export default {
		props: ['item'],
		data: function () {
			return {
				error: ''
			}
		},
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// number.vue?6bafe83e